<!--suppress EqualityComparisonWithCoercionJS -->
<template>
  <div :class="groupClass">
    <label :class="lableClass" :for="name">
      <slot>{{ title }}</slot>
    </label>

    <div :class="fieldClass">
      <!--Special Part Starts-->
      <div
        v-for="(option, index) in options"
        :key="index"
        class="form-check form-check-inline"
        style="margin-bottom: 0; margin-top: 5px"
      >
        <label class="form-check-label">
          <template v-if="isSimple">
            <input
              :checked="value == option"
              :class="{ 'is-invalid': form && form.errors.has(errorId) }"
              :disabled="isDisabled"
              :name="name"
              :value="option"
              class="form-check-input"
              type="radio"
              @change="update(option)"
            />
            {{ option }}
          </template>
          <template v-else>
            <input
              :checked="value == option[trackBy]"
              :class="{ 'is-invalid': form && form.errors.has(errorId) }"
              :disabled="isDisabled"
              :name="name"
              :value="option[trackBy]"
              class="form-check-input"
              type="radio"
              @change="update(option[trackBy])"
            />
            {{ option[label] }}
          </template>
        </label>
      </div>
      <!--Special Part Ends-->

      <div
        v-if="form && form.errors.has(errorId)"
        class="invalid-feedback"
        v-text="form.errors.get(errorId)"
      ></div>
      <slot name="note"></slot>
    </div>

    <div :class="extraSlotClass">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,

  props: {
    trackBy: {
      default: "id",
    },
    label: {
      default: "name",
    },
  },

  computed: {
    isSimple() {
      let simple = true;
      this.options.forEach((item) => {
        if (typeof item === "object") {
          simple = false;
        }
      });

      return simple;
    },
  },

  methods: {
    update(value) {
      if (this.form) {
        this.form.errors.clear(this.errorId);
      }

      this.$emit("input", value);
    },
  },
};
</script>
